var map = {
	"./adulto.svg": 3690,
	"./bars.svg": 6815,
	"./bioparque.svg": 7534,
	"./check.svg": 7325,
	"./church.svg": 2073,
	"./cross.svg": 7591,
	"./fast-clock.svg": 7674,
	"./ic_order.svg": 2739,
	"./ic_sepultamento.svg": 7882,
	"./ic_transport.svg": 8534,
	"./ic_velorio.svg": 8645,
	"./infantil.svg": 7895,
	"./legacy-logo-2.svg": 9121,
	"./legacy-logo.svg": 4313,
	"./logo_brand.svg": 6796,
	"./pattern_shields.svg": 3998,
	"./pig-bank.svg": 1834,
	"./prevent-icon.svg": 7411,
	"./primaveras/face.svg": 8458,
	"./primaveras/insta.svg": 2184,
	"./primaveras/location.svg": 3983,
	"./primaveras/mail-icon.svg": 7470,
	"./primaveras/phone-24h-footer.svg": 6672,
	"./primaveras/phone-24h.svg": 6851,
	"./primaveras/whats-footer.svg": 6259,
	"./primaveras/whatsapp.svg": 7569,
	"./primaveras/youtube.svg": 188,
	"./safe-check.svg": 6133,
	"./times.svg": 4002,
	"./transport-cross.svg": 5533,
	"./transport.svg": 2559,
	"./urna.svg": 8473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2498;